import React, { Component } from 'react';

// Used only for UserAuthWrapper
var PermissionBox = class extends React.Component {render()

  {
    return this.props.children;
  }};


export default PermissionBox;
